customElements.get("recommended-products-tabs") || customElements.define("recommended-products-tabs", class extends HTMLElement {
  constructor() {
    super(), this._activeTab = null, this._onTabClick = this._onTabClick.bind(this), 
    this._onKeyDown = this._onKeyDown.bind(this), this._onContentState = this._onContentState.bind(this);
  }
  connectedCallback() {
    this.sectionRoot = this.closest("[data-rp-section-root]"), this.tabButtons = Array.from(this.querySelectorAll("[data-rp-tab-button]")), 
    this.panels = Array.from(this.querySelectorAll("[data-rp-panel]")), this.unifiedControls = this.querySelector("[data-rp-controls-unified]"), 
    this.recentlySlider = this.querySelector("[data-rp-recently-slider]"), this.relatedProducts = this.querySelector("[data-rp-related-products]"), 
    this.sliderComponents = Array.from(this.querySelectorAll("slider-component[data-rp-slider-id]")), 
    this.tabButtons.length && (this.addEventListener("click", this._onTabClick), this.addEventListener("keydown", this._onKeyDown), 
    this.addEventListener("recently-viewed:state", this._onContentState), this.addEventListener("related-products:state", this._onContentState), 
    this._syncState());
  }
  disconnectedCallback() {
    this.removeEventListener("click", this._onTabClick), this.removeEventListener("keydown", this._onKeyDown), 
    this.removeEventListener("recently-viewed:state", this._onContentState), this.removeEventListener("related-products:state", this._onContentState);
  }
  _onContentState(t) {
    this.contains(t.target) && this._syncState();
  }
  _onTabClick(t) {
    const e = t.target.closest("[data-rp-tab-button]");
    if (!e) return;
    const s = e.dataset.rpTabButton;
    s && "true" !== e.getAttribute("aria-hidden") && (this._activeTab = s, this._syncState());
  }
  _onKeyDown(t) {
    const e = t.target.closest("[data-rp-tab-button]");
    if (!e) return;
    if ("Enter" === t.key || " " === t.key) return t.preventDefault(), void e.click();
    const s = this.tabButtons.filter(t => "true" !== t.getAttribute("aria-hidden"));
    if (!s.length) return;
    const i = s.indexOf(e);
    if (-1 === i) return;
    let r = -1;
    if ("ArrowRight" === t.key) r = (i + 1) % s.length; else if ("ArrowLeft" === t.key) r = (i - 1 + s.length) % s.length; else if ("Home" === t.key) r = 0; else {
      if ("End" !== t.key) return;
      r = s.length - 1;
    }
    t.preventDefault();
    const n = s[r];
    n.focus(), n.click();
  }
  _syncState() {
    this.sliderComponents = Array.from(this.querySelectorAll("slider-component[data-rp-slider-id]")), 
    this.recentlySlider = this.querySelector("[data-rp-recently-slider]"), this.relatedProducts = this.querySelector("[data-rp-related-products]");
    const t = {
      recently: this._hasRecentlyContent(),
      complementary: this._hasComplementaryContent()
    }, e = this.tabButtons.map(t => t.dataset.rpTabButton).filter(e => t[e]);
    e.includes(this._activeTab) || (e.includes("complementary") ? this._activeTab = "complementary" : this._activeTab = e[0] || null), 
    this.tabButtons.forEach(e => {
      const s = e.dataset.rpTabButton, i = !!t[s], r = s === this._activeTab && i;
      e.setAttribute("aria-hidden", i ? "false" : "true"), e.setAttribute("aria-selected", r ? "true" : "false"), 
      e.tabIndex = r ? 0 : -1;
    }), this.panels.forEach(e => {
      const s = e.dataset.rpPanel, i = s === this._activeTab && !!t[s];
      e.setAttribute("aria-hidden", i ? "false" : "true");
    });
    const s = this._getActiveSlider();
    if (this.sliderComponents.forEach(t => {
      t.dataset.rpActiveSlider = t === s ? "true" : "false";
    }), this.unifiedControls) {
      const t = this.unifiedControls.hasAttribute("data-slider-targets");
      s && this._activeTab ? (t || (this.unifiedControls.dataset.sliderTarget = s.dataset.sliderId || ""), 
      this.unifiedControls.setAttribute("aria-hidden", "false"), this.unifiedControls.dispatchEvent(new CustomEvent("slider-controls:refresh"))) : (t || delete this.unifiedControls.dataset.sliderTarget, 
      this.unifiedControls.setAttribute("aria-hidden", "true"));
    }
    this.sectionRoot && this.sectionRoot.setAttribute("aria-hidden", e.length ? "false" : "true");
  }
  _getActiveSlider() {
    return this._activeTab && this.querySelector(`slider-component[data-rp-slider-id="${this._activeTab}"]`) || null;
  }
  _hasRecentlyContent() {
    return !!this.recentlySlider?.querySelector("[data-slide]");
  }
  _hasComplementaryContent() {
    if (!this.relatedProducts) return !1;
    const t = this.relatedProducts.querySelector("[data-slider]");
    return !!t?.children.length || !this.relatedProducts.classList.contains("hidden") && "" !== this.relatedProducts.innerHTML.trim();
  }
});